// src/components/HomePage.js
import React from 'react';
import logo from '../WizeAssist_white_logo.png';
import ThreeDAnimation from './ThreeDAnimation';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaBolt, FaHeartbeat, FaChartBar } from 'react-icons/fa';
import '../styles/App.css'; // Import the consolidated App.css

function HomePage() {
  return (
    <main className="page-wrap">
      {/* HERO SECTION */}
      <section className="hero-section text-center">
        <div className="hero-content fade-bottom-onload container d-flex flex-column align-items-center justify-content-center">
          {/* WizeAssist White Logo */}
          <img
            src={logo}
            alt="WizeAssist Logo"
            className="hero-logo mb-3"
          />
          <h1>Elevate Your Training</h1>
          <p className="hero-text">
            Embrace the next era of sports performance. Our AI-driven platform
            delivers real-time insights, boundless motivation, and unstoppable energy.
            Step into the future and unlock your team potential.
          </p>

          {/* Centered Buttons with spacing */}
          <div className="cta-buttons d-flex justify-content-center mt-4 gap-3 flex-wrap">
            <a href="/login" className="btn btn-primary pulse-cta">
              Start Now
            </a>
            <a href="/pricing" className="btn btn-secondary">
              Plans
            </a>
          </div>
        </div>

        {/* 3D Animation */}
        <div className="hero-animation fade-top-onload">
          <ThreeDAnimation />
        </div>
      </section>

      {/* SOLUTIONS SECTION */}
      <section className="solutions-section text-center">
        <div className="container">
          <h2 className="text-teal mb-3">Who We Help</h2>
          <p>
            WizeAssist is your one-stop solution for diverse athletic needs. We cater to
            sports teams seeking group analytics, trainers looking for next-gen feedback,
            ,gyms for better retntion and clinics aiming to modernize patient rehab.
          </p>
          <div className="row g-4 justify-content-center">
            <div className="col-md-4">
              <div className="solution-card glass p-3">
                <h3>Sports Teams</h3>
                <p>
                  Rally the squad with unified data, track performance metrics,minimize injuries,
                  and push every player to their potential—together.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="solution-card glass p-3">
                <h3>Trainers</h3>
                <p>
                  Streamline client progress. Get real-time form checks,
                  personalized routines, and deeper analytics for next-level results.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="solution-card glass p-3">
                <h3>Clinics</h3>
                <p>
                  Improve patient outcomes with structured rehab protocols,
                  AI tracking, and compliance metrics to accelerate recovery.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* KEY HIGHLIGHTS SECTION */}
      <section className="feature-highlights text-center">
        <div className="container">
          <h2 className="text-teal mb-4">Key Highlights</h2>
          <div className="key-highlights-grid">
            <div className="feature-card glass p-4">
              <FaBolt
                size={40}
                className="mb-3"
                aria-label="Instant Feedback Icon"
              />
              <h3>Instant Feedback</h3>
              <p>
                Get real-time tips and corrections mid-workout.
                No guesswork—level up every move with AI precision.
              </p>
            </div>
            <div className="feature-card glass p-4">
              <FaHeartbeat
                size={40}
                className="mb-3"
                aria-label="Injury Prevention Icon"
              />
              <h3>Injury Prevention</h3>
              <p>
                Our AI constantly monitors your form, helping reduce risks
                and keep you in the game stronger, longer.
              </p>
            </div>
            <div className="feature-card glass p-4">
              <FaChartBar
                size={40}
                className="mb-3"
                aria-label="Deep Data Icon"
              />
              <h3>Deep Data</h3>
              <p>
                Track every rep and session in stunning detail.
                Compare past and present performance to see real progress.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* MARKETPLACE SECTION */}
      <section className="marketplace-section text-center">
        <div className="container">
          <h2 className="text-teal mb-3">Gear and Beyond</h2>
          <p>
            Explore our exclusive Marketplace for workout gear,
            supplements, and more. Level up with dumbbells, jump ropes,
            and many more items to enhance your training experience.
          </p>
          <a href="/marketplace" className="btn btn-primary">
            Visit Marketplace
          </a>
        </div>
      </section>

      {/* AI IN SPORTS / BLOG SECTION */}
      <section className="blog-section text-center">
        <div className="container">
          <h2 className="mb-3">Explore AI in Sports</h2>
          <p>
            Curious about how artificial intelligence is reshaping athletics?
            Check out our blog for the latest insights, tips, and breakthroughs
            in sports technology—and learn how to stay ahead of the game.
          </p>
          <div className="mt-3">
            <a href="/blog" className="btn btn-secondary">Read Our Blog</a>
          </div>
        </div>
      </section>

      {/* FINAL CTA SECTION */}
      <section className="final-cta-section text-center">
        <div className="container">
          <h2 className="mb-3">Ready to Transform?</h2>
          <p>
            Take the leap towards a smarter, safer, and stronger training experience.
            Dive in and discover the difference WizeAssist can make.
          </p>
          <div className="d-flex justify-content-center gap-3 flex-wrap">
            <a href="/login" className="btn btn-primary">Sign Up</a>
            <a href="/solutions" className="btn btn-secondary">Our Solutions</a>
          </div>
        </div>
      </section>
    </main>
  );
}

export default HomePage;
